import { URL_ANALYTICS_AD_PERFORMANCE } from '@seek/adv-constants';

export const buildAdPerformanceUrl = (jobId: string) =>
  `${URL_ANALYTICS_AD_PERFORMANCE}/${jobId}`;
